<template>
  <main id="app" class="container">
    <div class="card-wrapper row">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6">
        <Card>
          <CardSection class="card-header text-center">
            <div class="aec-logo">
              <img src="@/assets/logo_animod_dark2x.png"
                   alt="Logo der Animod GmbH" class="logo img-fluid"/>
            </div>

            <h1 class="header">
              Erhalten Sie hier Ihren zusätzlichen Gutschein
            </h1>
          </CardSection>

          <CardSection class="card-body">
            <template v-if="!success">
              <h2 class="subheader">
                Bitte geben Sie Ihre Animod-Gutscheinnummer (diese finden Sie oben rechts auf dem Gutschein) in das
                folgende Feld ein und gehen Sie auf »Abschicken«
              </h2>

<!--              <p>-->
<!--                <b>Hinweis:</b> Nach dem Erhalt Ihres 2. Gutscheins ist keine Stornierung des Animod-Gutscheins mehr-->
<!--                möglich.-->
<!--              </p>-->
            </template>

            <div v-if="code.error" class="alert alert-danger" role="alert">
              {{ errorText }}
            </div>

            <transition name="fade" mode="out-in">
              <Form v-if="!success"
                    @submit="submitForm"
                    :loading="loading"
                    :code.sync="code.value"
                    :email.sync="email.value"
              />
              <div v-else>
                <div v-if="code.success.errorText">
                  <h2 class="subheader" v-html="code.success.errorText"/>
                </div>
                <div v-else>
                  <template v-if="code.success.payload.type === 'PostalShipment'">
                    <p v-html="code.success.shippingInfoText" v-if="!shippingSuccess"/>
                    <div class="text-center" v-if="code.success.shippingRecordPresent === false">
                      <ShippingAddressForm v-if="!shippingSuccess"
                          @submit="submitShippingData"
                          :loading="loading"
                          :code="code.value"
                          :payload="code.success.payload.value"
                      />
                      <p v-html="code.success.text2" v-else />
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">
                      <strong class="subheader" v-if="code.success.payload.type === 'Download'"><a
                          :href="code.success.payload.value" class="btn btn-primary" target="_blank">Bonus
                        herunterladen</a></strong>
                      <strong class="subheader" v-else>
                        <pre>{{ code.success.payload.value }}</pre>
                      </strong>
                    </div>
                    <p v-html="code.success.text2"/>
                  </template>
                </div>

                <div v-if="email.error" class="alert alert-danger" role="alert">
                  <h2 class="subheader">
                    Newsletter:
                  </h2>
                  <p>{{ email.error }}</p>
                </div>
                <div v-else-if="email.success">
                  <h2 class="subheader">
                    Newsletter:
                  </h2>
                  <p>{{ emailSuccessText }}</p>
                </div>

                <div class="text-center">
                  <button class="btn btn-light btn-sm back-button" @click="back">
                    Zurück
                  </button>
                </div>
              </div>
            </transition>
          </CardSection>

          <CardSection class="card-footer">
            <FooterLinks/>
          </CardSection>

        </Card>
      </div>
    </div>
  </main>
</template>

<script>
import ajax from '@/ajax';
import FooterLinks from '@/components/FooterLinks';
import Card from '@/components/Card';
import CardSection from '@/components/CardSection';
import Form from '@/components/Form';
import ShippingAddressForm from "@/components/ShippingAddressForm.vue";

const params = new URLSearchParams(window.location.search);

export default {
  name: 'App',
  data() {
    return {
      code: {
        value: params.get("code"),
        loading: false,
        error: null,
        success: null,
        shippingRecordPresent: false,
        shippingSuccess: false
      },
      email: {
        value: null,
        loading: false,
        success: null,
        error: null
      },
    };
  },
  components: {
    ShippingAddressForm,
    FooterLinks,
    Card,
    CardSection,
    Form
  },
  computed: {
    loading() {
      return this.code.loading || this.email.loading
    },
    success() {
      return this.code.success
    },
    shippingSuccess() {
      return this.code.success && this.code.shippingSuccess;
    },
    errorText() {
      if (this.code.error) {
        if (this.code.error.response
            && this.code.error.response.status === 404) {
          return "Leider ist die Aktion bereits abgelaufen oder es wurden bereits alle Codes angefragt.";
        } else if (this.code.error.response
            && this.code.error.response.status === 400) {
          return "Ihre Gutscheinnummer " + this.code.value + " konnte nicht zugeordnet werden.\n\n"
              + "Bitte überprüfen Sie die Eingabe und versuchen Sie es erneut!";
        } else return "Leider ist ein Fehler aufgetreten";
      }
      return '';
    },
    emailSuccessText() {
      if (this.email.success.currentStatus === "pending") {
        return "Zu Ihrer Sicherheit erhalten Sie in Kürze eine E-Mail mit einem Bestätigungslink. Bitte klicken Sie auf diesen Link in der E-Mail, um Ihre Anmeldung zu bestätigen."
      } else if (this.email.success.currentStatus === "subscribed") {
        return "Sie sind bereits für unseren Newsletter angemeldet. Sollten Sie unseren Newsletter nicht erhalten, prüfen Sie bitte Ihren SPAM Ordner."
      }
    }
  },
  methods: {
    back() {
      this.code.shippingRecordPresent = false;
      this.code.shippingSuccess = null;
      this.code.success = null;
      this.email.value = null;
    },
    submitForm(code, email) {
      this.fetchIncentive(code)
      if (email) {
        this.postEmailSubscription(email)
      }
    },
    submitShippingData(data) {
      this.sendShippingData(data)
    },
    async postEmailSubscription(email) {
      this.email.loading = true;
      this.email.error = null;
      this.email.success = null;
      this.email.value = email;

      try {
        this.email.success = await ajax.postEmailSubscription(email);
      } catch (e) {
        this.email.error = e;

        if (process.env.NODE_ENV === "development") {
          console.log(e);
        }
      } finally {
        this.email.loading = false;
      }

    },
    async fetchIncentive(code) {
      this.code.loading = true;
      this.code.error = null;
      this.code.success = null;
      this.code.value = code;

      try {
        this.code.success = await ajax.fetchIncentive(code);
      } catch (e) {
        this.code.error = e;

        if (process.env.NODE_ENV === "development") {
          console.log(e);
        }
      } finally {
        this.code.loading = false;
      }

    },
    async sendShippingData(data) {
      this.code.loading = true;
      this.code.error = null;
      this.code.shippingSuccess = false;
      // this.code.success = null;

      try {
        let result = await ajax.sendShippingData(data);
        console.log(result);
        this.code.shippingSuccess = true;
      } catch (e) {
        this.code.error = e;

        if (process.env.NODE_ENV === "development") {
          console.log(e);
        }
      } finally {
        this.code.loading = false;
      }

    }
  }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

$primary-color: hsl(25, 100%, 60%);

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow: auto;

  .card-wrapper {
    min-height: 100%;
    justify-content: center;
    align-items: center;

    .card-header {
      .logo {
        width: 200px;
      }

      .header {
        margin: .625rem auto;
        text-align: center;
        color: hsl(0, 0%, 32%);
        font-size: 1.5rem;
      }
    }

    .card-body {
      height: auto;
      flex: 1 1 auto;

      .subheader {
        font-size: 1.25rem;
        margin-bottom: 1.5rem;
      }
    }

    .card-footer {
      background-color: hsla(0, 0%, 8%, 0.75);
    }
  }

  .back-button {
    margin-top: 1.5rem;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s ease;
  }

  .fade-enter, .fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .btn-primary {
    background-color: $primary-color;
    background-image: linear-gradient(180deg, hsl(25, 100%, 65%), hsl(25, 100%, 60%));
    border: none;
    box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, .2);
    color: #1c1c1c;
    font-weight: 700;
    letter-spacing: .0625rem;
    text-transform: uppercase;
  }
}
</style>
